module.exports = __webpack_public_path__ + "img/rosemount-848t-temperature-transmitter-1-front.b724b21c.png";